export default ({ date = null, message = null }) => ({
    interval: null,
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
    message: null,

    init() {
        this.message = message
        this.interval = setInterval(() => this.updateCountdown(date), 1000)

        this.updateCountdown(date)
    },

    updateCountdown(date) {
        const now = new Date()
        const target = new Date(date + '+02:00')
        const seconds = Math.floor((target - now) / 1000)

        if (seconds > 0) {
            this.days = Math.floor(seconds / 3600 / 24)
            this.hours = Math.floor((seconds / 3600) % 24)
            this.minutes = Math.floor((seconds / 60) % 60)
            this.seconds = Math.floor(seconds % 60)
        } else {
            this.interval = clearInterval(this.interval)
            this.days = 0
            this.hours = 0
            this.minutes = 0
            this.seconds = 0
        }
    },
})
